<template>
    <div class="home">
        <!-- <h1 class="subheading grey--text">Uploads</h1> -->

        <v-layout row wrap justify-space-between>
            <h1 class="subheading grey--text">Uploads</h1>
            <v-btn color="success" class="mr-5" @click="newBookModal = true">Adicionar Novo Livro</v-btn>
        </v-layout>

        <v-container class="sm-12 my-5">
            <v-expansion-panels popout multiple>
                <v-expansion-panel v-for="book in books" :key="book.id">
                    <v-expansion-panel-header  class="px-2">
                        Título: <span class="indigo--text font-weight-bold">{{ book.title }}</span> - Autor: <span class="indigo--text font-weight-bold">{{ book.creator }}</span>
                        <template v-slot:actions>
                            <v-icon class="mx-2" v-if="book.status === 0" color="yellow darken-2">fa-hourglass-start</v-icon>
                            <v-icon class="mx-2" v-else-if="book.status === 1" color="success">fa-check-circle</v-icon>
                            <v-icon class="mx-2" v-else-if="book.status === 2" color="error">fa-times-circle</v-icon>
                            <v-img class="mx-2" v-else width="20px" src="@/assets/loading.gif"></v-img>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <!-- <div class="font-weight-bold">{{ book.title}} - {{ book.creator }}</div> -->
                        <div>Publisher: <span class="indigo--text font-weight-bold">{{ book.publisher }}</span> - Descrição: <span class="indigo--text font-weight-bold">{{ book.description }}</span></div>
                        <v-divider></v-divider>
                        <div class="mt-5">
                            <span>Capa:</span>
                            <v-img 
                                width="200px" height="300px"
                                :src="book.coverURL" />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-container>

        <v-dialog v-model="newBookModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headling">
                        <v-icon left>fa-book</v-icon>Novo Livro
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-form class="px-4" v-model="valid" ref="newBookForm">
                        <v-text-field
                            label="Creator"
                            v-model="bookObj.bookCreator"
                            autofocus
                            counter
                            :rules="inputRules"
                        />

                        <v-text-field
                            label="Title"
                            v-model="bookObj.bookTitle"
                            counter
                            :rules="inputRules"
                        />

                        <v-text-field
                            label="Publisher"
                            v-model="bookObj.bookPublisher"
                            counter
                            :rules="inputRules"
                        />

                        <v-text-field
                            label="Description"
                            v-model="bookObj.bookDescription"
                            counter
                            :rules="inputRules"
                        />

                        <v-file-input 
                            v-model="fileBookUpload"
                            :rules="requiredRules" 
                            accept="application/pdf, application/epub+zip" 
                            show-size counter label="E-Book" 
                            @change="setEbook"></v-file-input>

                        <v-file-input 
                            v-model="fileCoverUpload"
                            :rules="requiredRules" 
                            accept="image/png, image/jpeg"
                            show-size counter label="Capa" 
                            @change="setCover"></v-file-input>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="error darken-1" @click="closeNewBookModal">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" :disabled="!valid" @click="addBook">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { func, db, storage } from "@/plugins/firebase";

// firebase events
let unsubscribe

export default {
    name: "Home",
    components: {},
    data: () => ({
        fileCoverUpload: null,
        fileBookUpload: null,
        newBookModal: false,
        // form fields
        valid: true,
        bookObj: {
            status: 0,
            bookCreator: "",
            bookTitle: "",
            bookPublisher: "",
            bookDescription: "",
            fileURL: '',
            coverURL: '',
        },
        inputRules: [v => v.length > 0 || "Mínimo é de 5 caracteres"],
        requiredRules: [v => v && v !== null || "Campo Obrigatório"],
        books: [],
        // sample_books: [
        //     {
        //         creator: "Herman Melville",
        //         title: "Moby Dick",
        //         publisher: "WOC",
        //         description: "UPLOAD TEST",
        //         password: "ebook2010",
        //         fileURL: '',
        //         coverURL: '',
        //         status: 0
        //     },
        //     {
        //         creator: "Matt Garrish",
        //         title: "Accessible EPUB 3",
        //         publisher: "WOC",
        //         description: "UPLOAD TEST 2",
        //         password: "ebook2010",
        //         fileURL: '',
        //         coverURL: '',
        //         status: 0
        //     }
        // ]
    }),
    computed: {
        // enableSaveButton() {
        //     return this.validate()
        // }
    },
    methods: {
        closeNewBookModal() {
            this.clearForm()
            this.$refs.newBookForm.resetValidation()
            this.newBookModal = false
        },
        clearForm() {
            this.bookObj = {
                bookCreator: "",
                bookTitle: "",
                bookPublisher: "",
                bookDescription: "",
                fileURL: '',
                coverURL: '',
                status: 3,
            };
            this.bookFile = null;
            this.bookCover = null;
            this.fileCoverUpload = null,
            this.fileBookUpload = null
        },
        async addBook() {
            if (!this.$refs.newBookForm.validate()) {
                return;
            }

            this.$store.dispatch(
                "SHOW_GLOBAL_PROGRESS_DIALOG",
                "Salvando livro, aguarde ..."
            );

            let bookToSave = {
                creator: this.bookObj.bookCreator,
                title: this.bookObj.bookTitle,
                publisher: this.bookObj.bookPublisher,
                description: this.bookObj.bookDescription,
                fileURL: this.bookObj.fileURL,
                coverURL: this.bookObj.coverURL,
                status: 0
            }

            const sb = func.httpsCallable("saveBookMetadata");
            sb({ book: bookToSave })
                .then(res => {
                    console.log(res.data);
                    this.$store.dispatch("HIDE_GLOBAL_PROGRESS_DIALOG");
                    this.clearForm();
                    this.newBookModal = false
                })
                .catch(error => {
                    console.log(`Erro: ${error}`);
                    this.$store.dispatch("HIDE_GLOBAL_PROGRESS_DIALOG");
                });
        },
        async setEbook(e) {
            let file = e;

            // removeu o arquivo
            if ( e === null || e === undefined ) {
                return
            }

            const tt = new Date().getTime()

            this.$store.dispatch('SHOW_GLOBAL_PROGRESS_DIALOG', 'Analisando arquivo, por favor, aguarde ...')
            
            let sRef = storage.ref(`${tt}_${file.name}`);
            let uploadTask = sRef.put(file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done`);
                },
                function(error) {
                    console.log(`Error fazendo upload ${error}`)
                    this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                },
                () => {
                    uploadTask.snapshot.ref
                        .getDownloadURL()
                        .then((downloadURL) => {
                            // console.log(`File available at ${downloadURL}`);
                            this.bookObj.fileURL = downloadURL
                            this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                        });
                }
            )
        },
        async setCover(e) {
            let file = e
            // removeu o arquivo
            if ( e === null || e === undefined ) {
                return
            }

            const tt = new Date().getTime()

            this.$store.dispatch('SHOW_GLOBAL_PROGRESS_DIALOG', 'Analisando arquivo, por favor, aguarde ...')

            let sRef = storage.ref(`${tt}_${file.name}`);
            let uploadTask = sRef.put(file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done`);
                },
                function(error) {
                    console.log(`Error fazendo upload ${error}`)
                    this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                },
                () => {
                    uploadTask.snapshot.ref
                        .getDownloadURL()
                        .then((downloadURL) => {
                            // console.log(`File available at ${downloadURL}`);
                            this.bookObj.coverURL = downloadURL
                            this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                        });
                }
            )            
        },
    },
    mounted() {
        unsubscribe = db.collection('books')
            .onSnapshot(res => {
                const changes = res.docChanges()

                changes.forEach(change => {
                    if ( change.type == 'added' ) {
                        this.books.push({
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                    }
              
                    if ( change.type === 'removed' ) {
                        for (var i = 0; i < this.books.length; ++i) {
                            if (this.books[i].id === change.doc.id) {
                                this.books.splice(i, 1)
                                break
                            }
                        }
                    }

                    if ( change.type === 'modified' ) {
                        for (var j = 0; j < this.books.length; ++j) {
                            if (this.books[j].id === change.doc.id) {
                                this.books.splice(j, 1, change.doc.data())
                                this.books[j].id = change.doc.id
                                break
                            }
                        }
                    }
                })
            })
    },
    beforeDestroy() {
        unsubscribe()
    }
};
</script>
